module.exports = __webpack_public_path__ + "deluxe-r6e_KR.jpg";